import { useCallback, useEffect, useState, useRef } from "react";
import { Route, Routes, Navigate, useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setShowOrganizationModal } from "./redux/actions/actions";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import { onMessageListener } from "./firebase/firebase";
import { showInfoToast } from "./toast/toast";
import { setNavigate } from "./navigationService";
import { syncChatsToIndexedDB } from "./services/chatSyncService";
/* Auth Components */
import Login from "./user/login/Login";
import Createaccount from "./user/create-account/Createaccount";
/* User Components */
import Mainlayout from "./user/main-layout/Mainlayout";
import Home from "./user/home/Home";
// import Community from "./user/community/Community";
import Community from "./user/new-community/Community";
import Mapsites from "./user/sites/Mapsites";
import Rewardlayout from "./user/rewards-store/Rewardlayout";
import MyStore from "./user/rewards-store/MyStore";
import EarnBuilderBucks from "./user/rewards-store/EarnBuilderBucks";
import AccountActivity from "./user/rewards-store/AccountActivity";
import Timesheets from "./user/timesheets/Timesheets";
import Expenses from "././user/expenses/Expenses";
import ResumeBuilder from "./user/resume-builder/ResumeBuilder";
import AddResume from "./user/resume-builder/AddResume";
import Questions from "./user/rewards-store/Quistions";
import Tickets from "./user/tickets/Tickets";
import Montages from "./user/montages/Montages";
import MontageForm from "./user/montages/MontageForm";
import BuilderNetwork from "./user/builder-network/BuilderNetwork";
import Carpool from "./user/carpool/Carpool";
import JobPosting from "./user/job-posting/JobPostings";
import Companies from "./user/companies/Companies";
import CompanyProfile from "./user/companies/CompanyProfile";
import Manufactures from "./user/manufactures/Manufactures";
import ManufactureProfile from "./user/manufactures/ManufatureProfile";
import Products from "./user/products/Products";
import ProductProfile from "./user/products/ProductProfile";
import Trades from "./user/trades/Trades";
import TradeProfile from "./user/trades/TradeProfile";
import ProjectProfile from "./user/projects/ProjectProfile";
import Search from "./user/global-search/Search";
import NewProfile from "./user/profile/NewProfile";
import Settings from "./user/setting/Settings";
import CloseAccount from "./user/setting/CloseAccount";
/* Chat Components */
import Alertinformation from "./user/common/Alertinformation";
/* Client Components */
import ClientLayout from "./client/layout/ClientLayout";
import ClientHome from "./client/home/ClientHome";
import ClientPictureboard from "./client/picutreboard/ClientPictureboard";
import ClientActions from "./client/actions/ClientActions";
import ClientActionsDetails from "./client/actions/ClientActionsDetails";
import ClientChangeTracker from "./client/change-tracker/ClientChangeTracker";
import ClientCoaching from "./client/coaching/ClientCoaching";
import Communicator from "./client/communicator/ClientCommunicator";
import ClientExpenses from "./client/expenses/ClientExpenses";
import EquipmentInspections from "./client/equipment-inspection/EquipmentInspections";
import AddEquipmentInspections from "./client/equipment-inspection/AddEquipmentInspections";
import ClientQualityControl from "./client/quality-control/ClientQualityControl";
import ClientQualityControlDetails from "./client/quality-control/ClientQualityControlDetails";
import ClientSafetyIncident from "./client/safety-incident/ClientSafetyIncident";
import ClientSafetyObservation from "./client/safety-observation/ClientSafetyObservation";
import ClientSAR from "./client/site-activity-report/ClientSAR";
import ClientSiteEstimates from "./client/site-estimates/ClientSiteEstimates";
import ClientSiteFiling from "./client/site-filing/ClientSiteFiling";
import ClientSiteFilingFolder from "./client/site-filing/ClientSiteFilingFolder";
import ClientSiteFilingFolderListing from "./client/site-filing/ClientSiteFilingFolderListing";
import ClientSupport from "./client/support/ClientSupport";
import ClientTakeFive from "./client/take-five/ClientTakeFive";
import ClientVideos from "./client/videos/ClientVideos";
import TutorialVideos from "./client/tutorial-videos/TutorialVideos";
import ClientTutorialVideos from "./client/tutorial-videos/ClientTutorialVideos";
import TimesheetsDashboard from "./client/timesheets/TimesheetsDashboard";
import ClientFallBack from "./client/clientFallBack/ClientFallBack";
import ClientNotification from "./client/notification/ClientNotification";
import AdminPortalLayout from "./client/admin-portal/AdminPortalLayout";
import AdminPortalEmployees from "./client/admin-portal/Employees";
import AdminPortalJobs from "./client/admin-portal/Jobs";
import "./App.css";
import { Inspections } from "./client/inspection/Inspections";
import ClientChat from "./client/chat/ClentChat";
import MyJobPosting from "./user/job-posting/MyJobPosting";
import Workpackage from "./client/clientWorkPackage/Workpackage";
import WorkPackageView from "./client/clientWorkPackage/WorkPackageView";
import SelectOrganizationModal from "./user/login/SelectOrganization";
import SignalR, { SignalRMethod } from "./common/SignalR";
import ChatLayout from "./user/chat/ChatLayout";
import BuySell from "./user/buysell/BuySell";
import MyListings from "./user/buysell/MyListings";
import WorkBuddyInvite from "./user/workbuddy/InvitationWebPage";
import AcceptedPage from "./user/workbuddy/AcceptedPage";
import InvitationPage from "./user/invitation/InvitationPage";
import FixedAssets from "./client/fixed-assets/FixedAssets";
import UserTickets from "./user/tickets/UserTickets";

/* Force Open Modal Component */
const ForceSelectOrganization = () => {
  const dispatch = useDispatch();
  const isClientRoute = window.location.href.includes("client");

  useEffect(() => {
    if (!isClientRoute) {
      dispatch(setShowOrganizationModal(true));
    }
  }, [dispatch, isClientRoute]);

  if (isClientRoute) {
    return null;
  }

  return (
    <div style={{ padding: "40px", textAlign: "center", fontSize: "18px" }}>
      <h2>Access Restricted</h2>
      <p>Please select an organization to continue.</p>
    </div>
  );
};

function App() {
  const { loginData, selectedClientData } = useSelector((state) => state?.main);
  const navigate = useNavigate();
  const location = useLocation();
  window.axios = axios;

  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIphone = /iPhone/i.test(navigator.userAgent);
  const isIpad = /iPad/i.test(navigator.userAgent);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const isAuthenticated = loginData?.sourceDataFrom ? false : Boolean(loginData?.accessToken);

  const hasBIAccess = () => {
    if (!selectedClientData) {
      return !false;
    }
    const access = selectedClientData?.HideBiFree;
    return !access;
  };

  // For SignalR connection start
  useEffect(() => {
    if (loginData?.accessToken) {
      setLoading(true);
      SignalR.connect(loginData)
        .then(async () => {
          // Sync chats to IndexedDB after successful SignalR connection
          // This ensures we have the latest chat data when user returns to the site
          await syncChatsToIndexedDB(dispatch, loginData);
          setLoading(false);
        })
        .catch(() => {
          console.log("Signal R Failed to connect");
          setLoading(false);
        });
      return () => {
        SignalR.removeListener("SignalRTest");
        SignalR.disconnect();
        setLoading(false);
      };
    }
  }, [loginData?.accessToken, dispatch]);

  const wasInChat = useRef(false);

  useEffect(() => {
    const isInChat = location.pathname.includes("chat");
    if (loginData?.accessToken && !isInChat && wasInChat.current) {
      try {
        const userId = loginData?.userInformation?.UserId;
        const deviceId = loginData?.userInformation?.DeviceId;
        if (userId && deviceId) {
          SignalR.invoke(SignalRMethod.CHANGE_CURRENT_ACTIVE_GROUP, [userId, deviceId, 0]);
        }
      } catch (error) {
        console.error("Error invoking CHANGE_CURRENT_ACTIVE_GROUP:", error);
      }
    }
    wasInChat.current = isInChat;
  }, [location.pathname, loginData?.accessToken]);

  useEffect(() => {
    const requestNotificationPermission = async () => {
      try {
        await Notification.requestPermission();
      } catch (error) {
        console.error("Error requesting notification permission:", error);
      }
    };
    requestNotificationPermission();

    onMessageListener()
      .then((messaging) => {
        return messaging.onMessage((payload) => {
          triggerNotify(payload);
        });
      })
      .catch((err) => console.error("Failed to set up message listener:", err));
  }, []);

  const triggerNotify = (payload) => {
    const title = payload?.data?.Title || payload?.notification?.title || "New Notification";
    const body = payload?.data?.Body || payload?.notification?.body || "";
    showInfoToast(
      `${title}: ${body}`,
      payload?.data || payload?.notification || {},
      navigate,
      dispatch,
      loginData
    );
  };

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    const loader = document.getElementById("initial-loader");
    if (loader) {
      setTimeout(() => {
        loader.style.display = "none";
      }, 500); // Small delay for smooth transition
    }
  }, []);

  const openInPhone = useCallback(
    (screenName, id) => {
      if (isAndroid) {
        if (id) {
          const androidUrl = `intent://?screenName=${screenName}&id=${id}#Intent;scheme=mybuilderid;package=com.mybuilderid;end`;
          window.location.replace(androidUrl);
        } else {
          const androidUrl = `intent://?screenName=${screenName}#Intent;scheme=mybuilderid;package=com.mybuilderid;end`;
          window.location.replace(androidUrl);
        }

        return;
      } else if (isIphone || isIpad) {
        if (id) {
          const iPhoneUrl = `mybuilderid://?screenName=${screenName}&id=${id}`;
          window.location.replace(iPhoneUrl);
        } else {
          const iPhoneUrl = `mybuilderid://?screenName=${screenName}`;
          window.location.replace(iPhoneUrl);
        }
        return;
      }
    },
    [isAndroid, isIpad, isIphone]
  );

  useEffect(() => {
    if (!isAuthenticated) {
      // const storedRoute = sessionStorage.getItem("redirectAfterLogin");
      const isExcludedPath =
        location.pathname.includes("forgot-password") ||
        location.pathname.includes("create-account") ||
        location.pathname.includes("refer") ||
        location.pathname.includes("proxySite") ||
        location.pathname.includes("workBuddyInvite") ||
        location.pathname.includes("invitation") ||
        location.pathname.includes("accepted") ||
        location.pathname.includes("user-tickets");

      if (!isExcludedPath && location.pathname !== "/" && (isAndroid || isIpad || isIphone)) {
        const screenName = getScreenName(location.pathname);
        const id = getIdFromPath(location.pathname);
        openInPhone(screenName, id);
      }
    }
  }, [isAuthenticated, location, isAndroid, isIpad, isIphone, openInPhone]);

  useEffect(() => {
    if (isAuthenticated) {
      const redirectPath = sessionStorage.getItem("redirectAfterLogin");
      if (
        (isAndroid || isIpad || isIphone) &&
        location.pathname !== "/" &&
        !location.pathname.includes("forgot-password") &&
        !location.pathname.includes("create-account") &&
        !location.pathname.includes("refer") &&
        !location.pathname.includes("proxySite") &&
        !location.pathname.includes("workBuddyInvite") &&
        !location.pathname.includes("invitation") &&
        !location.pathname.includes("accepted") &&
        !location.pathname.includes("user-tickets")
      ) {
        const screenName = getScreenName(location.pathname);
        const id = getIdFromPath(location.pathname);
        openInPhone(screenName, id);
      }
    }
  }, [isAuthenticated, navigate, isAndroid, isIpad, isIphone, location.pathname, openInPhone]);

  const getIdFromPath = (pathname) => {
    const match = pathname.match(/\/(\d+)$/);
    return match ? match[1] : null;
  };

  const getScreenName = (pathname) => {
    const profileRegex = /^\/\d+$/;
    console.log("pathname", pathname);
    const normalizedPath = pathname.replace(/\/\d+$/, "");
    console.log("normalizedPath", normalizedPath)
    const isProfile = profileRegex.test(pathname); // true
    if (isProfile) {
      return "ProfileBoard";
    }

    switch (normalizedPath) {
      case "/timesheets":
        return "Timesheet";
      case "/sites":
        return "Sites";
      case "/expenses":
        return "Expenses";
      case "/job-postings":
        return "JobPostings";
      case "/carpool":
        return "Carpool";
      case "/workbuddy":
        return "WorkBuddy";
      case "/resume-builder":
        return "ResumeBuilder";
      case "/tickets":
        return "Tickets";
      case "/montages":
        return "Montage";
      case "/contacts":
        return "BuilderNetwork";
      case "/companies":
        return "Companies";
      case "/manufactures":
        return "Manufactures";
      case "/manufacture":
        return "ManufacturerInfo";
      case "/company":
        return "CompanyInfo";
      case "/product":
        return "ProductInfo";
      case "/trade":
        return "TradeDetail";
      case "/project":
        return "ProjectPage";
      case "/products":
        return "Products";
      case "/trades":
        return "Trades";
      case "/buy-sell":
        return "BuySell";
      case "/":
        return "Home";
      case "home":
        return "Home";
      case "/chat":
        return "Chat";
      default:
        return "Home";
    }
  };

  const routes = [
    {
      path: "job-postings/*",
      provider: null,
      element: <JobPosting />
    },
    {
      path: "montages/*",
      provider: null,
      element: (
        <Routes>
          <Route index element={<Montages />} />
          <Route path=":action/:id?" element={<MontageForm />} />
        </Routes>
      )
    },
    {
      path: "montages/add",
      provider: null,
      element: <MontageForm />
    },
    {
      path: "timesheets",
      provider: null,
      element: <Timesheets />
    },
    {
      path: "resume-builder",
      provider: null,
      element: <ResumeBuilder />
    },
    {
      path: "resume-builder/add",
      provider: null,
      element: <AddResume />
    }
  ];

  const ReferRedirect = () => {
    const { id } = useParams();
    return <Navigate to={`/${id}`} replace />;
  };

  const UserTicketRedirect = () => {
    const { id } = useParams();
    sessionStorage.setItem("userTicketId", id);
    return <Navigate to="/" replace />;
  };

  return (
    <>
      <SelectOrganizationModal />
      <Routes>
        {!isAuthenticated ? (
          <>
            {/* ============ UNAUTHENTICATED ROUTES ============ */}
            <Route path="/create-account" element={<Createaccount />} />
            <Route path="/refer/:referId/" element={<Createaccount />} />
            <Route path="/forgot-password/:email/:guideId" element={<Login />} />
            <Route path="proxySite/CompanyInfo/:id" element={<CompanyProfile />} />
            <Route path="proxySite/ProductInfo/:id" element={<ProductProfile />} />
            <Route path="proxySite/ManufacturerInfo/:id" element={<ManufactureProfile />} />
            <Route path="proxySite/TradeDetail/:id" element={<TradeProfile />} />
            <Route path="proxySite/ProjectPage/:id" element={<ProjectProfile />} />
            <Route exact index path="/" element={<Login />} />
            {!isAndroid && !isIphone && !isIpad && (
              <Route path="*" element={<Navigate to="/" replace />} />
            )}
            {sessionStorage.getItem("logoutClicked") ? (
              <></>
            ) : (
              <Route path="user-tickets/:id" element={<UserTicketRedirect />} />
            )}
          </>
        ) : (
          <>
            {/* ============ AUTHENTICATED ROUTES ============ */}
            <Route path="/forgot-password/:email/:guideId" element={<Login />} />
            {/* {!selectedClientData?.HideBiFree ? ( */}
            {!hasBIAccess() === false ? (
              <>
                {/* ============ USER ROUTES WITH BI ACCESS ============ */}
                <Route element={<Mainlayout loading={loading} />}>
                  <Route path="/" element={<Home />} />
                  <Route index path="home" element={<Home />} />
                  <Route path="community" element={<Community />} />
                  <Route path="sites" element={<Mapsites />} />
                  <Route path="expenses" element={<Expenses />} />
                  <Route path="tickets" element={<Tickets />} />
                  <Route path="carpool" element={<Carpool />} />

                  <Route path="user-tickets/:id" element={<UserTickets />} />

                  {/* BuySell */}
                  <Route path="buy-sell">
                    <Route index element={<BuySell />} />
                    <Route path="my-listing" element={<MyListings />} />
                  </Route>

                  {/* Contacts */}
                  <Route path="contacts">
                    <Route index element={<BuilderNetwork />} />
                    <Route path=":userId" element={<NewProfile />} />
                  </Route>

                  {/* Dynamic Routes */}
                  {routes.map(({ path, provider: Provider, element }) =>
                    Provider ? (
                      <Route key={path} path={path} element={<Provider>{element}</Provider>} />
                    ) : (
                      <Route key={path} path={path} element={element} />
                    )
                  )}

                  {/* Resume Builder */}
                  <Route path="resume-builder/*" element={<ResumeBuilder />} />
                  <Route path="resume-builder/add-resume" element={<AddResume />} />

                  {/* Reward Store */}
                  <Route path="reward-store" element={<Rewardlayout />}>
                    <Route index element={<EarnBuilderBucks />} />
                    <Route path="earn-builderbucks">
                      <Route index element={<EarnBuilderBucks />} />
                      <Route path="earn-rewards" element={<Questions />} />
                    </Route>
                    <Route path="my-store" element={<MyStore />} />
                    <Route path="account-activity" element={<AccountActivity />} />
                  </Route>

                  {/* Companies */}
                  <Route path="companies" element={<Companies />} />
                  <Route path="company/:id" element={<CompanyProfile />} />

                  {/* Manufacturers */}
                  <Route path="manufactures" element={<Manufactures />} />
                  <Route path="manufacture/:id" element={<ManufactureProfile />} />

                  {/* Products */}
                  <Route path="products" element={<Products />} />
                  <Route path="product/:id" element={<ProductProfile />} />

                  {/* Trades */}
                  <Route path="trades" element={<Trades />} />
                  <Route path="trade/:id" element={<TradeProfile />} />

                  {/* Projects */}
                  <Route path="project/:id" element={<ProjectProfile />} />

                  {/* Settings */}
                  <Route path="content-search" element={<Search />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="tutorial-videos" element={<TutorialVideos />} />
                  <Route path="close-account" element={<CloseAccount />} />
                  <Route path="my-postings" element={<MyJobPosting />} />
                  <Route path="chat" element={<ChatLayout />} />

                  {/* Profile - Last to avoid conflicts */}
                  <Route path=":userId" element={<NewProfile />} />
                  <Route path="select/org" element={<ForceSelectOrganization />} />
                  <Route path="refer/:id/" element={<ReferRedirect />} />
                </Route>
              </>
            ) : (
              <Route path="*" element={<ForceSelectOrganization />} />
            )}
            {/* ============ CLIENT ROUTES ============ */}
            <Route path="client/:id" element={<ClientLayout />}>
              <Route path="home" element={<ClientHome />} />
              <Route path="picture-board" element={<ClientPictureboard />} />
              <Route path="chat" element={<ClientChat />} />
              <Route path="client-notifications" element={<ClientNotification />} />
              <Route path="admin-portal" element={<AdminPortalLayout />}>
                <Route index element={<Navigate to="employees" replace />} />
                <Route path="employees" element={<AdminPortalEmployees />} />
                <Route path="jobs" element={<AdminPortalJobs />} />
              </Route>
              <Route path="support-requests" element={<ClientSupport />} />
              <Route path="safety-incidents" element={<ClientSafetyIncident />} />
              <Route path="coaching" element={<ClientCoaching />} />
              <Route path="communicator" element={<Communicator />} />
              <Route path="timesheets" element={<TimesheetsDashboard />} />
              <Route path="expenses" element={<ClientExpenses />} />
              <Route path="quality-control">
                <Route index element={<ClientQualityControl />} />
                <Route path=":qid" element={<ClientQualityControlDetails />} />
              </Route>
              <Route path="safety-observations" element={<ClientSafetyObservation />} />
              <Route path="change-tracker" element={<ClientChangeTracker />} />
              <Route path="site-activity-reports" element={<ClientSAR />} />
              <Route path="actions">
                <Route index element={<ClientActions />} />
                <Route path=":aid" element={<ClientActionsDetails />} />
              </Route>
              <Route path="take5" element={<ClientTakeFive />} />
              <Route path="site-estimates" element={<ClientSiteEstimates />} />
              <Route path="site-filing">
                <Route index element={<ClientSiteFiling />} />
                <Route path=":siteid" element={<ClientSiteFilingFolder />} />
                <Route path=":siteid/:folderId" element={<ClientSiteFilingFolderListing />} />
              </Route>
              <Route path="videos" element={<ClientVideos />} />
              <Route path="client-tutorial-videos" element={<ClientTutorialVideos />} />
              <Route path="equipment-inspection">
                <Route index element={<EquipmentInspections />} />
                <Route path=":qid" element={<AddEquipmentInspections />} />
              </Route>
              <Route path="inspections">
                <Route index element={<Inspections />} />
              </Route>
              <Route path="work-package">
                <Route index element={<Workpackage />} />
                <Route path=":workPackageid" element={<WorkPackageView />} />
              </Route>
              <Route path="fixed-assets">
                <Route index element={<FixedAssets />} />
              </Route>
              {/* Fallback for unmatched client routes */}
              <Route path="*" element={<ClientFallBack />} />
            </Route>
          </>
        )}
        <Route path="/workBuddyInvite/:userId/:workBuddyId" element={<WorkBuddyInvite />} />
        <Route path="/invitation/:clientId/:userEmail" element={<InvitationPage />} />
        <Route path="/accepted" element={<AcceptedPage />} />
      </Routes>
      <Alertinformation />
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </>
  );
}

export default App;
